module.exports = __webpack_public_path__ + "static/media/Thyroid.a602f8c0.gif";